import { app } from '../../app.module'
/**
 * 月を選択するフォーム。月を選択した場合、イベントを送信する
 * attribute: {boolean} allow-null trueの場合は、プルダウンメニューの先頭に'指定しない'を表示する
 */
class MonthFormComponentCtrl {
  private scope: ng.IScope
  private label: string
  private months: (string | number)[]
  private month: string | number
  private allowNull: string

  constructor($scope) {
    this.scope = $scope
    this.label = '月'
    this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    this.month = null
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    // attrにallow-nullがあり、trueの場合は、プルダウンメニューの先頭に'指定しない'を追加する
    if (this.allowNull !== undefined && this.allowNull === 'true') {
      this.months.unshift('指定しない')
    }

    // 編集としてモーダルが呼ばれた際は、既存のタグをセットする
    this.scope.$on('setEventData', (event, eventData) => {
      this.month = eventData.month
    })
  }

  /**
   * 選択した月をイベント送信する
   * @param  {number|string} selectedMonth
   */
  public selectMonth(selectedMonth: string) {
    if (selectedMonth === '指定しない') {
      selectedMonth = null
    }

    // イベントをemitする
    this.scope.$emit('selectMonth', selectedMonth)
  }
}

app.component('monthForm', {
  template: require('./month-form.pug')(),
  bindings: {
    allowNull: '@',
  },
  controller: MonthFormComponentCtrl,
})
